const config = {
  api_base_url: 'https://legalapi.orbmusic.com.br',
  site_base_url: 'https://legal.orbmusic.com.br',
  orb_auth_url: 'https://auth.orbmusic.com.br?app=029f7dfd0c4d565c532933281c44e8012551d90264d2cb83083560f2d21b0135',
  orb_profile_url: 'https://auth.orbmusic.com.br/profile',
  orb_logout_url: 'https://auth.orbmusic.com.br/logout?app=029f7dfd0c4d565c532933281c44e8012551d90264d2cb83083560f2d21b0135'
};

export default config;